import { removeHash } from "../../../../lib";

export default () => {
	const hash = location.hash;

	if (!hash) {
		return null;
	}

	const parsed = hash.match(/^#cl_(uk|ru)$/);

	if (!parsed) {
		return null;
	}

	const lang = parsed[1];
	const entryId = craft.page.coursesStatsConfig.entryId;

	if (!entryId) {
		console.error('Course lang check: Hash value has been granted, but entryId is not defined in page config, so cookie hasn\'t been set');
	}

	/* Expiration: 1 month */
	costorage.set(`h_cl-${entryId}`, lang, { expires: 2592000, path: '/', domain: '.ithillel.ua' });
	removeHash();

	return lang;
};
